export default __webpack_public_path__ + "static/media/gato.2d7901e1.png";